export const sortTypes = ['text', 'number']

export const clSortDatas = function ({datas, sortType, funSort, type, key}) {
  if (datas.length < 2 || type === null) {
    return datas
  }
  let useFun = null
  if (funSort) {
    useFun = funSort
  } else if (sortType === 'text') {
    useFun = sortText
  } else {
    useFun = sortNumber
  }
  for (let indexA in datas) {
    for (let indexB in datas) {
      let nIndexB = Number(indexB)
      if (nIndexB < (datas.length - 1 - indexA) && useFun(datas[nIndexB][key] || datas[nIndexB], datas[nIndexB + 1][key] || datas[nIndexB + 1], type)) {
        [datas[nIndexB], datas[nIndexB + 1]] = [datas[nIndexB + 1], datas[nIndexB]]
      }
    }
  }
  return datas
}

const sortText = function (a, b, type) {
  a = a || ''
  b = b || ''
  return type === 'desc' ? (a > b) : (a < b)
}

const sortNumber = function (a, b, type) {
  a = Number(a) || 0
  b = Number(b) || 0
  return type === 'desc' ? (a > b) : (a < b)
}

export const tableSortDatas = function (dataList, relationSort, sortMap, sortConfig, sortOrder) {
  if (!sortMap) {
    return dataList
  }
  // 关联排序
  let i = relationSort.length - 1
  while (i > -1) {
    let field = relationSort[i]
    let type = sortMap[field]
    if (type) {
      dataList = clSortDatas({datas: dataList, sortType: sortConfig[field], type, key: field})
    }
    i = i - 1
  }
  let sortData = dataList
  // 按照指定的先后顺序排序
  if (sortOrder && sortOrder.length > 0) {
    for (let sort of sortOrder) {
      let type = sortMap[sort.field]
      if (!relationSort.includes(sort.field) && type) {
        sortData = deepSort(sortData, sortConfig[sort.field], type, sort.field)
      }
    }
  } else {
    for (let field in sortMap) {
      let type = sortMap[field]
      if (!relationSort.includes(field) && type) {
        sortData = deepSort(sortData, sortConfig[field], type, field)
      }
    }
  }
  return implodeGroup([], sortData)
}

export function deepSort (datas, sortConfig, type, key) {
  if (Array.isArray(datas) && datas.length > 0 && !Array.isArray(datas[0])) {
    return splitGroup(clSortDatas({datas, sortType: sortConfig.by, funSort: sortConfig.fun, type, key}), key)
  } else {
    return datas.map(v => {
      if (Array.isArray(v) && v.length > 0) {
        if (Array.isArray(v[0])) {
          return deepSort(v, sortConfig, type, key)
        } else {
          return splitGroup(clSortDatas({datas: v, sortType: sortConfig.by, funSort: sortConfig.fun, type, key}), key)
        }
      } else {
        return v
      }
    })
  }
}

export function splitGroup (array, field) {
  let groups = []
  let his = {}
  array.forEach(v => {
    if (his[v[field]] === undefined) {
      his[v[field]] = groups.length
      groups.push([])
    }
    groups[his[v[field]]].push(v)
  })
  return groups
}

export function implodeGroup (prev, current) {
  if (Array.isArray(current)) {
    prev = current.reduce(implodeGroup, prev)
  } else if (current) {
    prev.push(current)
  }
  return prev
}



// WEBPACK FOOTER //
// ./src/fm-table/lib/sort_list.js